import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { MyDraggable as Draggable } from '../components/Core';
import HoverBar from '../components/HoverBar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Row, Col } from 'reactstrap';
import { generateStyle, setOverLay, l } from '../functions';
import Icon from '../components/Icons';
import noImage from '../../img/nophotoproduct.jpg';
import axios from 'axios';
import { ajaxUri } from '../consts/index';
import isEqual from 'lodash/isEqual';

const mapStateToProps = (state) => {
  return {
    fetchedCategories: state.rootReducer.fetchedCategories || {},
    currentDevice: state.rootReducer.currentDevice || 'xl',
    settings: state.rootReducer?.appearanceSettings || {},
    showGlobalList: state.rootReducer?.showGlobalList ?? true,
  };
};

class CatsList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      categoriesImages: {},
    };

    this.categories = [];
    this.catPos = [];
  }

  _catImg = (id_category) => {
    axios({
      method: 'post',
      url: ajaxUri,
      data: {
        request: 'getCategoryImage',
        id_category: id_category,
      },
    })
      .then((result) => {
        this.setState({
          categoriesImages: {
            ...this.state.categoriesImages,
            ...{ [id_category]: result.data || noImage },
          },
        });
      })
      .catch((error) => {
        this.setState({
          categoriesImages: {
            ...this.state.categoriesImages,
            ...{ [id_category]: noImage },
          },
        });
      });
  };

  componentWillReceiveProps({ payload }) {
    let categories = [];

    if (payload && payload.datas && payload.datas.categoriesList) categories = payload.datas.categoriesList;

    if (this.categories !== categories) {
      this.categories = categories;

      for (const id_category of categories) {
        if (!this.state.categoriesImages[id_category]) this._catImg(id_category);
      }
    }
  }

  _filterCategory = (cats = []) => {
    if (!this.props.showGlobalList) {
      return cats;
    }

    const filteredCats = [];
    this.catPos = [];

    let categories = JSON.parse(JSON.stringify(this.props.fetchedCategories.normal || []));
    categories = categories.filter((a) => a?.position);

    categories.sort((a, b) => {
      // console.log(a.position, b.position);
      const ap = a.position;
      const bp = b.position;
      return ap - bp;
    });
    // console.log(categories);

    categories.forEach((cat, index) => {
      if (cats.includes(cat?.id)) {
        filteredCats.push(cat.id);
        this.catPos[cat.id] = index;
      }
    });

    // console.log(filteredCats);

    return filteredCats;
  };

  _displayCatsList = (payload) => {
    const cssSettings = generateStyle(payload, 'container');
    const cssSettingsText = generateStyle(payload, 'text', 'H4');

    const { catsPerRowLg, catsPerRowMd, catsPerRowSm, catsPerRowXs } = (payload && payload.datas) || {
      catsPerRowLg: 12,
      catsPerRowMd: 12,
      catsPerRowSm: 12,
      catsPerRowXs: 12,
    };
    const colsize = {
      xl: catsPerRowLg,
      lg: catsPerRowLg,
      md: catsPerRowMd,
      sm: catsPerRowSm,
      xs: catsPerRowXs,
    };
    let categories = [];

    if (payload && payload.datas && payload.datas.categoriesList) categories = payload.datas.categoriesList;

    categories = this._filterCategory(categories);
    // console.log(categories);

    return (
      (categories && categories.length && (
        <Container fluid={payload.fullContainer} style={cssSettings} className='categories-list'>
          {setOverLay(payload)}
          <Row>
            {categories.map((id_category, index) => {
              let category = null;
              category = this.props.fetchedCategories.normal && this.props.fetchedCategories.normal[id_category];

              console.log(category);
              return (
                (category && (
                  <Col
                    className={`col ${payload.datas.displayModeCats ? payload.datas.displayModeCats : 'tiles'}`}
                    key={index}
                    xs={colsize[this.props.currentDevice] || 12}
                  >
                    {payload.datas.displayModeCats && payload.datas.displayModeCats === 'blocks' ? (
                      <div className='content'>
                        <div
                          className='cat-img'
                          style={{
                            backgroundImage: `url(${this.state.categoriesImages[id_category] || noImage})`,
                          }}
                        ></div>
                        <h3 style={cssSettingsText}>{category.name}</h3>
                      </div>
                    ) : (
                      <div
                        className='content'
                        style={{
                          backgroundImage: `url(${this.state.categoriesImages[id_category] || noImage})`,
                        }}
                      >
                        <div>
                          <h4 style={cssSettingsText}>{category.name}</h4>
                        </div>
                      </div>
                    )}
                  </Col>
                )) || (
                  <Col
                    className={`col ${payload.datas.displayModeCats ? payload.datas.displayModeCats : 'tiles'}`}
                    key={index}
                    xs={colsize[this.props.currentDevice] || 12}
                  >
                    {payload.datas.displayModeCats && payload.datas.displayModeCats === 'blocks' ? (
                      <div className='content'>
                        <div className='cat-img' style={{ backgroundImage: `url(${noImage})` }}></div>
                        <h4 style={cssSettingsText}>{l('Please select a category')}</h4>
                      </div>
                    ) : (
                      <div className='content' style={{ backgroundImage: `url(${noImage})` }}>
                        <div>
                          <h4 style={cssSettingsText}>{l('Please select a category')}</h4>
                        </div>
                      </div>
                    )}
                  </Col>
                )
              );
            })}
          </Row>
        </Container>
      )) || (
        <div className='gk-error-message inline'>
          <p>{l('Please select a category')}</p>
        </div>
      )
    );
  };

  shouldComponentUpdate(nextProp, nextState) {
    const nextPayload = nextProp?.payload;
    const currentPayload = this.props?.payload;
    const categories = currentPayload?.datas?.categoriesList;
    const nextCat = nextPayload?.datas?.categoriesList;
    if (categories && nextCat && categories !== nextCat) {
      return true;
    }

    if (
      !isEqual(nextPayload, currentPayload) ||
      !isEqual(nextProp.settings, this.props.settings) ||
      this.props.showGlobalList !== nextProp.showGlobalList
    ) {
      return true;
    }
    return false;
  }

  render() {
    let { dropzoneID, parentID, showBasicContent, showPreview, id, dropzoneProps, payload, ...rest } = this.props;

    if (payload === null) payload = this.props.options.payload;

    if (showBasicContent) {
      return (
        <Draggable {...this.props} side={true}>
          <span className='dragger'>
            {(Array.isArray(rest.icon) && <FontAwesomeIcon icon={rest.icon} />) || <Icon icon={rest.icon} />}
            <span>{l(rest.name)}</span>
          </span>
        </Draggable>
      );
    }

    if (showPreview) {
      return this._displayCatsList(payload);
    }

    return (
      <Draggable {...this.props} minify={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        {this._displayCatsList(payload)}
      </Draggable>
    );
  }
}

CatsList.propTypes = {
  id: PropTypes.string.isRequired,
  showBasicContent: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(CatsList);
